(function () {
  var PAGE_SIZE = 5;
  var DISPLAY_RATING = '4.9';
  var DISPLAY_TOTAL = 3645;
  var DISPLAY_COUNTS = { 1: 7, 2: 10, 3: 40, 4: 195, 5: 3093 };
  var STAR_PATH = 'M6.89132 1.87331C7.08291 1.28367 7.91709 1.28367 8.10868 1.87331L9.04017 4.74014C9.12585 5.00384 9.37158 5.18237 9.64884 5.18237H12.6632C13.2832 5.18237 13.541 5.97573 13.0394 6.34014L10.6007 8.11194C10.3764 8.27491 10.2825 8.56379 10.3682 8.82748L11.2997 11.6943C11.4913 12.284 10.8164 12.7743 10.3149 12.4099L7.87618 10.6381C7.65187 10.4751 7.34813 10.4751 7.12382 10.6381L4.68515 12.4099C4.18357 12.7743 3.5087 12.284 3.70029 11.6943L4.63178 8.82748C4.71746 8.56379 4.62359 8.27491 4.39928 8.11194L1.96061 6.34014C1.45903 5.97573 1.71681 5.18237 2.33679 5.18237H5.35116C5.62842 5.18237 5.87415 5.00384 5.95983 4.74014L6.89132 1.87331Z';

  function getAgeHours(index) {
    if (index === 0) return 3;
    if (index === 1) return 11;
    if (index === 2) return 23;
    if (index === 3) return 30;
    if (index <= 7) return 49 + (index - 4) * 5;
    if (index <= 10) return 73 + (index - 8) * 5;
    return (4 + Math.floor((index - 11) / 3)) * 24 + 6;
  }

  function formatRelativeTime(hours) {
    if (hours < 24) return hours + ' hours ago';
    if (hours < 48) return 'yesterday';
    return Math.floor(hours / 24) + ' days ago';
  }

  function formatDate(hours) {
    var date = new Date(Date.now() - hours * 60 * 60 * 1000);
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '.' + month + '.' + day;
  }

  function setText(root, selector, value) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value;
  }

  function buildRating(element, rating) {
    var namespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('width', '81');
    svg.setAttribute('height', '15');
    svg.setAttribute('viewBox', '0 0 81 15');
    svg.setAttribute('aria-hidden', 'true');

    for (var star = 0; star < 5; star += 1) {
      var path = document.createElementNS(namespace, 'path');
      path.setAttribute('d', STAR_PATH);
      path.setAttribute('transform', 'translate(' + star * 16.5 + ' 0)');
      path.setAttribute('fill', star < rating ? '#0E9A2A' : 'rgba(25, 25, 25, 0.15)');
      svg.appendChild(path);
    }

    var value = document.createElement('span');
    value.className = 'sp-7-routine__card-rating-num';
    value.textContent = rating + '/5';
    element.setAttribute('aria-label', rating + ' out of 5 stars');
    element.appendChild(svg);
    element.appendChild(value);
  }

  function makeGradientIds(card, sectionKey, reviewIndex) {
    card.querySelectorAll('[data-verified-gradient]').forEach(function (gradient, badgeIndex) {
      var id = 'sp-7-routine-verified-' + sectionKey + '-' + reviewIndex + '-' + badgeIndex;
      gradient.id = id;
      var svg = gradient.closest('svg');
      var fill = svg && svg.querySelector('[data-verified-gradient-fill]');
      if (fill) fill.setAttribute('fill', 'url(#' + id + ')');
    });
  }

  function addImages(media, review) {
    if (!Array.isArray(review.images) || !review.images.length) return;

    review.images.forEach(function (url, imageIndex) {
      if (!/^https:\/\//i.test(url)) return;
      var link = document.createElement('a');
      link.className = 'sp-7-routine__card-media-link';
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      var image = document.createElement('img');
      image.className = 'sp-7-routine__card-image';
      image.src = url;
      image.alt = 'Photo ' + (imageIndex + 1) + ' from ' + review.author + "'s review";
      image.loading = 'lazy';
      image.decoding = 'async';
      image.addEventListener('error', function () {
        link.remove();
        if (!media.children.length) media.hidden = true;
      });

      link.appendChild(image);
      media.appendChild(link);
    });

    if (media.children.length) media.hidden = false;
  }

  function buildCard(root, template, review, index) {
    var fragment = template.content.cloneNode(true);
    var card = fragment.querySelector('[data-review-card]');
    var ageHours = getAgeHours(index);

    card.dataset.reviewIndex = String(index);
    card.dataset.reviewProduct = review.product;
    setText(card, '[data-review-author]', review.author);
    setText(card, '[data-review-title]', review.title);
    setText(card, '[data-review-body]', review.body);
    card.querySelectorAll('[data-review-relative-time]').forEach(function (element) {
      element.textContent = formatRelativeTime(ageHours);
    });
    setText(card, '[data-review-date]', formatDate(ageHours));

    var title = card.querySelector('[data-review-title]');
    if (title && !review.title) title.hidden = true;
    var rating = card.querySelector('[data-review-rating]');
    if (rating) buildRating(rating, review.rating);
    var media = card.querySelector('[data-review-media]');
    if (media) addImages(media, review);
    makeGradientIds(card, root.id.replace(/[^a-z0-9_-]/gi, ''), index);
    return fragment;
  }

  function updateSummary(root, reviews) {
    var displayTotal = Number(root.dataset.reviewTotal) || DISPLAY_TOTAL;
    var breakdownTotal = Object.keys(DISPLAY_COUNTS).reduce(function (sum, rating) {
      return sum + DISPLAY_COUNTS[rating];
    }, 0);

    setText(root, '[data-sp-7-routine-average]', DISPLAY_RATING);
    setText(root, '[data-sp-7-routine-based-on]', 'Based on ' + displayTotal.toLocaleString('en-US') + ' reviews');
    setText(root, '[data-sp-7-routine-total]', displayTotal.toLocaleString('en-US') + ' reviews');

    [5, 4, 3, 2, 1].forEach(function (rating) {
      setText(root, '[data-sp-7-routine-count="' + rating + '"]', DISPLAY_COUNTS[rating].toLocaleString('en-US'));
      var bar = root.querySelector('[data-sp-7-routine-bar="' + rating + '"]');
      if (bar) bar.style.width = (DISPLAY_COUNTS[rating] / breakdownTotal * 100).toFixed(1) + '%';
      var filter = root.querySelector('[data-sp-7-routine-filter="' + rating + '"]');
      if (filter) filter.setAttribute('aria-label', 'Filter reviews by ' + rating + ' stars (' + DISPLAY_COUNTS[rating] + ' reviews)');
    });
  }

  function initialize(root) {
    if (!root || root.dataset.sp7RoutineInitialized === 'true') return;
    var displayTotal = Number(root.dataset.reviewTotal) || DISPLAY_TOTAL;
    var pageSize = window.matchMedia('(max-width: 650px)').matches
      ? Number(root.dataset.reviewMobilePageSize) || PAGE_SIZE
      : Number(root.dataset.reviewPageSize) || PAGE_SIZE;
    var reviews = Array.isArray(window.Arq8Sp7RoutineReviews) ? window.Arq8Sp7RoutineReviews : [];
    var featuredReviewIndex = root.dataset.reviewPinFeatured === 'false' ? -1 : reviews.findIndex(function (review) {
      return review.author === 'Kevin Cicchini'
        && review.title === 'Thank you so much for your help pursuing my Dream';
    });
    if (featuredReviewIndex > 0) {
      reviews = reviews.slice();
      reviews.unshift(reviews.splice(featuredReviewIndex, 1)[0]);
    }
    var list = root.querySelector('[data-sp-7-routine-reviews-list]');
    var template = root.querySelector('[data-sp-7-routine-review-template]');
    var button = root.querySelector('[data-sp-7-routine-load-more]');
    var sortSelect = root.querySelector('[data-sp-7-routine-sort]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-sp-7-routine-filter]'));
    if (!list || !template || !button) return;

    function sortReviews() {
      if (!sortSelect) return;
      var order = sortSelect.value;
      reviews = reviews.slice().sort(function (a, b) {
        var dateOrder = (b.sourceDate || '').localeCompare(a.sourceDate || '');
        if (order === 'highest') return b.rating - a.rating || dateOrder;
        if (order === 'lowest') return a.rating - b.rating || dateOrder;
        return dateOrder;
      });
    }

    sortReviews();

    root.dataset.sp7RoutineInitialized = 'true';
    updateSummary(root, reviews);
    var visibleCount = 0;
    var activeRating = null;
    var activeReviews = reviews;

    function updateFilterState() {
      filters.forEach(function (filter) {
        var isActive = Number(filter.getAttribute('data-sp-7-routine-filter')) === activeRating;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', String(isActive));
      });

      if (activeRating === null) {
        setText(root, '[data-sp-7-routine-total]', displayTotal.toLocaleString('en-US') + ' reviews');
      } else {
        setText(
          root,
          '[data-sp-7-routine-total]',
          DISPLAY_COUNTS[activeRating].toLocaleString('en-US') + ' ' + activeRating + '-star reviews'
        );
      }
    }

    function renderNextPage() {
      var end = Math.min(visibleCount + pageSize, activeReviews.length);
      var fragment = document.createDocumentFragment();
      for (var index = visibleCount; index < end; index += 1) {
        var review = activeReviews[index];
        fragment.appendChild(buildCard(root, template, review, reviews.indexOf(review)));
      }
      list.appendChild(fragment);
      visibleCount = end;
      var finished = visibleCount >= activeReviews.length;
      button.hidden = finished;
      button.setAttribute('aria-expanded', String(visibleCount > pageSize));
    }

    function applyFilter(rating) {
      activeRating = activeRating === rating ? null : rating;
      activeReviews = activeRating === null
        ? reviews
        : reviews.filter(function (review) { return review.rating === activeRating; });
      visibleCount = 0;
      list.replaceChildren();
      updateFilterState();
      renderNextPage();
    }

    button.addEventListener('click', renderNextPage);
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortReviews();
        activeReviews = activeRating === null
          ? reviews
          : reviews.filter(function (review) { return review.rating === activeRating; });
        visibleCount = 0;
        list.replaceChildren();
        renderNextPage();
      });
    }
    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        applyFilter(Number(filter.getAttribute('data-sp-7-routine-filter')));
      });
    });
    updateFilterState();
    renderNextPage();
  }

  function initializeAll(scope) {
    if (scope && scope.matches && scope.matches('[data-sp-7-routine]')) initialize(scope);
    (scope || document).querySelectorAll('[data-sp-7-routine]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
